import * as actionTypes from "../actionTypes/Index";

import { EVENT_TYPE, UPLOAD_CSV_TYPE, shiftMigrationTempWarhouseIds } from "./../../config/constants";
import {
  addTourCsvForShiftUploadApiCall,
  startShiftApiCall,
  updateShiftApiCall,
} from "../sources/WarehouseOpsSource";

import { Dispatch } from "react";
import { IActionType } from "../../interfaces/Index";
import { IGetWarehouseShiftResponse } from "../../interfaces/shiftDetail.interface";
import { UPLOAD_TOUR_FOR_SHIFT_URL, UPLOAD_TOUR_FOR_SHIFT_URL_V2 } from "config/Url";

export const startShiftInit = () => ({
  type: actionTypes.START_WAREHOUSE_SHIFT_INIT,
});

export const startShiftSuccess = (payload: string) => ({
  type: actionTypes.START_WAREHOUSE_SHIFT_SUCCESS,
  payload,
});

export const startShiftFail = (error: string | object | null) => ({
  type: actionTypes.START_WAREHOUSE_SHIFT_FAIL,
  error,
});

export const endShiftInit = () => ({
  type: actionTypes.END_WAREHOUSE_SHIFT_INIT,
});

export const endShiftSuccess = (payload: IGetWarehouseShiftResponse) => ({
  type: actionTypes.END_WAREHOUSE_SHIFT_SUCCESS,
  payload,
});

export const endShiftFail = (error: string | object | null) => ({
  type: actionTypes.END_WAREHOUSE_SHIFT_FAIL,
  error,
});

export const uploadTourForWarehouseShiftInit = () => ({
  type: actionTypes.UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_INIT,
});

export const uploadTourForWarehouseShiftSuccess = () => ({
  type: actionTypes.UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_SUCCESS,
});

export const uploadTourForWarehouseShiftFail = (
  error: string | object | null
) => ({
  type: actionTypes.UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_FAIL,
  error,
});

// async actions
export const startWarehouseShift =
  (warehouseId: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(startShiftInit());
    return startShiftApiCall(warehouseId)
      .then((payload: IGetWarehouseShiftResponse) =>
        dispatch(startShiftSuccess(payload.shiftId))
      )
      .catch((e: object | null | string) => dispatch(startShiftFail(e)));
  };

export const endWarehouseShift =
  (shiftId: string, eventType: EVENT_TYPE) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(endShiftInit());
    return updateShiftApiCall(shiftId, eventType)
      .then((payload: IGetWarehouseShiftResponse) =>
        dispatch(endShiftSuccess(payload))
      )
      .catch((e: object | null | string) => dispatch(endShiftFail(e)));
  };

export const uploadTourCsvForWarehouseShiftAndUpdateShiftEvent =
  (
    shiftId: string,
    eventType: EVENT_TYPE,
    type: UPLOAD_CSV_TYPE,
    payload: FormData,
    warehouseId: string
  ) => 
  (dispatch: Dispatch<IActionType>) => {
    let url = UPLOAD_TOUR_FOR_SHIFT_URL.replace("{upload-type}", type)
      .replace("{shift-id}", shiftId)
      .replace("{warehouse-id}", warehouseId);

    // NOTE: This is temporary for migration
    const isWarehouseEligibleForMigration = shiftMigrationTempWarhouseIds.includes(warehouseId);
    if(isWarehouseEligibleForMigration) {
      url = UPLOAD_TOUR_FOR_SHIFT_URL_V2;
      payload.append('type',type);
      payload.append('warehouseId', warehouseId);
    }

    dispatch(uploadTourForWarehouseShiftInit());
    const promise = addTourCsvForShiftUploadApiCall(url, payload)

    let reference = null;
     // NOTE: This is temporary for migration
    if(!isWarehouseEligibleForMigration) {
      reference = promise.then(() => updateShiftApiCall(shiftId, eventType))
    }
    return (reference || promise).then(() => dispatch(uploadTourForWarehouseShiftSuccess())).catch((e: object | null | string) =>
      dispatch(uploadTourForWarehouseShiftFail(e))
    );
  };
